module.exports = __webpack_public_path__ + "media/images/emoticons/nosmoking-f1a7f6295b13aa9dafb13985850b10fe.gif";